import type { Category } from '@/mocks/articles';

interface CategoryTabsProps {
  categories: Category[];
  activeSlug: string;
  onSelect: (slug: string) => void;
}

export default function CategoryTabs({ categories, activeSlug, onSelect }: CategoryTabsProps) {
  return (
    <div className="flex items-center gap-2 overflow-x-auto pb-2">
      <button
        onClick={() => onSelect('all')}
        className={`px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
          activeSlug === 'all'
            ? 'bg-primary-500 text-background-50'
            : 'bg-background-100 text-foreground-600 hover:bg-background-200'
        }`}
      >
        全部文章
      </button>
      {categories.map((cat) => (
        <button
          key={cat.slug}
          onClick={() => onSelect(cat.slug)}
          className={`flex items-center gap-1.5 px-4 py-2 rounded-full text-sm font-medium whitespace-nowrap transition-all ${
            activeSlug === cat.slug
              ? 'bg-primary-500 text-background-50'
              : 'bg-background-100 text-foreground-600 hover:bg-background-200'
          }`}
        >
          <i className={`${cat.icon} text-sm`}></i>
          {cat.name}
        </button>
      ))}
    </div>
  );
}